import styled from "styled-components";

export const Space = styled.div`
  width: 100%;
  height: 24px;
`;